import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { stopAllNarration } from "@/lib/narrator";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AppShell from "@/components/AppShell";
import Projects from "@/pages/Projects";
import Studio from "@/pages/Studio";
import ArtRoom from "@/pages/ArtRoom";
import SessionHub from "@/pages/SessionHub";
import Office from "@/pages/Office";
import Vault from "@/pages/Vault";
import Chat from "@/pages/Chat";
import VideoChat from "@/pages/VideoChat";
import Library from "@/pages/Library";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import VenueShare from "@/pages/VenueShare";
import PayInvoice from "@/pages/PayInvoice";
import Billing from "@/pages/Billing";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { getUser, getToken } from "@/lib/store";

const Protected = ({ children }) => (getUser() && getToken() ? children : <Navigate to="/app" replace />);

function AudioGuard() {
  const { pathname } = useLocation();
  useEffect(() => { stopAllNarration(); }, [pathname]);
  return null;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app" element={<Auth />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/w" element={<Protected><AppShell /></Protected>}>
            <Route index element={<Navigate to="projects" replace />} />
            <Route path="projects" element={<Projects />} />
            <Route path="studio" element={<Library kind="studio" />} />
            <Route path="studio/library" element={<Library kind="studio" />} />
            <Route path="studio/:id" element={<Studio />} />
            <Route path="art" element={<Library kind="art" />} />
            <Route path="art/library" element={<Library kind="art" />} />
            <Route path="art/:id" element={<ArtRoom />} />
            <Route path="sessions" element={<SessionHub />} />
            <Route path="office" element={<Office />} />
            <Route path="vault" element={<Vault />} />
            <Route path="chat" element={<Chat />} />
            <Route path="chat/:sessionId" element={<Chat />} />
            <Route path="video" element={<VideoChat />} />
            <Route path="video/:sessionId" element={<VideoChat />} />
            <Route path="billing" element={<Billing />} />
          </Route>
          <Route path="/share/:token" element={<VenueShare />} />
          <Route path="/pay/:token" element={<PayInvoice />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AudioGuard />
        <AppRoutes />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
